import { deviceType, deviceModel, pageUrl, pagePath, pageReferer, viewportWidth, viewportHeight } from "./browserUtils";
import type { DeviceType } from "./browserUtils.d";

export { deviceType, DeviceType, deviceModel, pageUrl, pagePath, pageReferer, viewportWidth, viewportHeight };
